import { ICoverShipmentInput, IAvailableTruckInput, ICoverBid } from 'types/graphqlTypes'
import { TCoverModalSchema } from '../schema/CoverModalSchema'
import { getFormattedDate } from './getFormattedDate'

export const prepareCoverInput = (
  shipmentId: string,
  data: TCoverModalSchema,
  timezone?: string
): ICoverShipmentInput => {
  const manualEta =
    data.assignDriverTime === 'now'
      ? getFormattedDate(data.etaDate, data.etaTime, timezone)
      : undefined
  const facility = data.etaDriverLocation
  const { city: truckLocationCity = '', state: truckLocationStateCode = '' } =
    facility?.location || {}
  const availableTruckInfo: IAvailableTruckInput = {
    truckLocationCity,
    truckLocationStateCode,
    vin: data.vinNumber,
    truckNumber: data.truckNumber,
    ...(data.trailerNumber?.trim() ? { trailerNumber: data.trailerNumber } : {}), // Do not send trailer number if empty
  }
  const bid: ICoverBid = {
    amount: data.rate || 0,
    carrierContactUserId: data.carrierContactId,
    carrierContactName: data.bookingContactName,
    carrierContactPhone: data.bookingContactPhone,
    carrierContactPhoneExt: data.bookingContactPhoneExt,
    carrierApplicationId: data.carrierApplicationId,
    driverId: data.driverId,
    carrierAvailableTruck: truckLocationStateCode ? availableTruckInfo : undefined,
  }
  return {
    shipmentId,
    bid,
    carrierContactInstructions: data.additionalCarrierInfo ?? undefined,
    manualEta,
    lateReason: data.lateReason ? data.lateReason : undefined,
  }
}
